// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__7dLrb"};